export default __webpack_public_path__ + "static/media/mtc_animated_compressed.6b889933.GIF";